import createActions from '../../config/actions/createActions';
import { action } from '@play-co/replicant';
import * as getters from './match2-tournament.getters';
import * as modifiers from './match2-tournament.modifiers';

/** Development mode only, not allowed in production  */
export const match2TournamentCheats = createActions({
  /**
   * Clear all tournaments data
   */
  cheat_resetMatch2Tournaments: action((state, args: void, api) => {
    state.match2.tournament.events = {};
  }),

  /**
   * Reset existing tournament event, so that can be played again
   */
  cheat_resetMatch2TournamentEvent: action(
    (state, args: { eventId: string }, api) => {
      modifiers.resetEvent(state, args.eventId, api.date.now());
    },
  ),

  /**
   * Increase user score in current tournament
   */
  cheat_increaseMatch2TournamentScore: action(
    (state, args: { score: number }, api) => {
      const now = api.date.now();
      const period = getters.getTournamentPeriod(state, now);
      if (!period || period.end < now) return;

      // Create a new evet if it doesn't exist yet
      if (!state.match2.tournament.events[period.eventId]) {
        modifiers.createTournament(state, period.eventId, period.type, now);
      }

      const data = state.match2.tournament.events[period.eventId];
      if (!data) return;
      // reset the tournament if it was finished already
      if (data.finalRank) {
        modifiers.resetEvent(state, period.eventId, api.date.now());
      }
      data.player.score += args.score;
      data.player.scoreUpdatedAt = api.date.now();
    },
  ),

  /**
   * Finish current match2 tournament
   */
  cheat_finishCurrentMatch2Tournament: action(
    (state, args: { position: number }, api) => {
      const event = getters.getOngoingEvent(state, api.date.now());
      if (!event) return;
      const data = state.match2.tournament.events[event.id];
      if (!data) return;
      data.finalRank = args.position;
    },
  ),

  /**
   * Add a dummy opponent to the current tournament event
   */
  cheat_addDummyMatch2TournamentOpponent: action((state, _, api) => {
    const event = getters.getOngoingEvent(state, api.date.now());
    if (!event) return;
    const data = state.match2.tournament.events[event.id];
    if (!data) return;
    const id = `${data.opponentList.length}`;
    data.opponentList.push(id);
  }),
});
